import { render, staticRenderFns } from "./FormEkspektasiPerilaku.vue?vue&type=template&id=720a32b4&lang=html&"
import script from "./FormEkspektasiPerilaku.vue?vue&type=script&lang=js&"
export * from "./FormEkspektasiPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports